import { createReducer } from '@src/redux/helpers/createReducer';
import { SET_ONLOADING, SET_CURRENT_FLOW } from './constants';

const initialState = {
  intros: {},
  tooltips: {},
  dbValues: {},
  currentFlow: '',
};

export const onLoadingReducer = createReducer(initialState, {
  [`${SET_ONLOADING}_SUCCESS`]: (state, action) => {
    return action.payload;
  },
  [`${SET_CURRENT_FLOW}`]: (state, action) => {
    return { ...state, currentFlow: action.payload };
  },
});
